import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  padding-top: 70px;
  padding-bottom: 70px;
  margin-top: -32px;
  border-radius: 32px 32px 0 0;
  background-color: ${p => p.theme.palette.home.left};

  ${breakpoints.down('xs')} {
    text-align: center;

    .sellInternet {
      &__title {
        line-height: 30px;
      }
    }
  }
`;

export default Container;
